import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../components/snackbar';
import { NOTIFICATIONS_GET_ALL_OK, NOTIFICATIONS_DISMISS_OK, LOADING, COMPLETE } from './types';
import { call } from '../utilities/http';
import { sortByDate } from '../utilities/time';

const defaultState = {
    list: undefined
};

/**
 * Notifications state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case NOTIFICATIONS_GET_ALL_OK:
            return { ...state, list: action.data };

        case NOTIFICATIONS_DISMISS_OK:
            let notifications = state.list ? state.list.filter(n => n.id !== action.data.id) : [];
            return { ...state, list: notifications };

        default:
            return state;
    }
}

export function getNotifications(userRole, user = undefined, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getNotifications'} defaultMessage={'Unable to retrieve notifications.'} />;
    const { role, type, id } = userRole;
    const queryParams = {
        recipient_role: role,
        recipient_ref_id: id,
        recipient_ref_type: type
    };
    if (user) {
        queryParams['recipient_user_id'] = user.id;
    }

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/notification`, queryParams })
            .then(response => {
                const urgent = response ? response.filter(r => r.type === 'urgent') : [];
                const other = response ? response.filter(r => r.type !== 'urgent') : [];
                const data = [...sortByDate(urgent, 'updated_at', false), ...sortByDate(other, 'updated_at', false)];

                dispatch({ type: NOTIFICATIONS_GET_ALL_OK, data });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function dismissNotification(notification, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.dismissNotification'} defaultMessage={'Unable to dismiss alert.'} />;
    const { id } = notification;
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/notification/${id}/action/dismiss`, method: 'POST' })
            .then(response => {
                dispatch({ type: NOTIFICATIONS_DISMISS_OK, data: notification });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/notifications.jsx